import React, { useState } from "react";
import TreatmentApi from "../../../services/TreatmentApi";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  FormControlLabel,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { ModeEditOutlineSharp } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import { THEME_COLOR } from "../../../config";
export default function GetAllTreatments(props) {
  const { getServices } = props;
  console.log("Treatments Data", getServices);
  const { updateTreatmentStatus, deleteTreatment, updatePrescriptionStatus } =
    TreatmentApi();
  const [show, setShow] = useState(false);
  const [treatmentId, setTreatmentId] = useState("");
  const [activeModal, setActiveModal] = useState();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:  768px)");
  const [showInPrescription, isSelectedForBilling] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const handleShow = (id) => {
    setTreatmentId(id);
    setShow(true);
  };

  const handlePrescriptionCheckbox = (treatmentId, checked) => {
    console.log("Treatment:", treatmentId);
    console.log("Checked:", checked);

    updatePrescriptionStatus(treatmentId, {
      showInPrescription: checked,
    }).then(() => {
      props.refreshData?.();
    });
  };

  const handleClose = () => setShow(false);

  const handleDone = (treatmentId) => {
    const status = {
      status: "Completed",
    };
    updateTreatmentStatus(treatmentId, status)
      .then(() => {
        props.refreshData?.();
      })
      .finally(() => {
        setShow(false);
      });
  };
  const openDrawerWithModal = (modalType, item) => {
    setActiveModal(modalType);
    setDrawerOpen(true);
  };

  const handleDeleteClose = () => {
    setShowDelete(false);
    setTreatmentId("");
  };

  const handleDeleteShow = (id) => {
    setTreatmentId(id);
    setShowDelete(true);
  };
  function deletetreatments(id) {
    deleteTreatment(id).then(() => {
      props.refreshData?.();
      handleDeleteClose();
    });
  }
  return (
    <>
      <>
        {getServices && getServices.length > 0 ? (
          <div className="margin_top_15">
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <span className="patientModal">Index</span>
                    </TableCell>
                    <TableCell align="center">
                      <span className="patientModal">Treatment Name</span>
                    </TableCell>
                    <TableCell align="center">
                      <span className="patientModal">Doctor Name</span>
                    </TableCell>
                    <TableCell align="center">
                      <span className="patientModal">Fees</span>
                    </TableCell>
                    <TableCell align="center">
                      <span className="patientModal">Plan Date</span>
                    </TableCell>
                    <TableCell align="center">
                      <span className="patientModal">Status</span>
                    </TableCell>
                    <TableCell align="center">Prescription</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getServices &&
                    getServices.map((item, i) => {
                      console.log("-----item", item);
                      return (
                        <TableRow key={i}>
                          <TableCell align="center">{i + 1}</TableCell>
                          <TableCell align="center">
                            {item.treatmentName}
                          </TableCell>
                          <TableCell align="center">
                            {item["doctorList"][0].name}
                          </TableCell>
                          <TableCell align="center">
                            {item.treatmentPrice}
                          </TableCell>
                          <TableCell align="center">
                            {moment(item.planDate).format("YYYY-MM-DD")}
                          </TableCell>
                          <TableCell align="center">{item.status}</TableCell>
                          <TableCell align="center">
                            {item.parentId === item.doctorId ? (
                              <div className="mt-2">
                                {item.status === "Completed" ? null : (
                                  <Link
                                    to="#"
                                    onClick={() => handleShow(item._id)}
                                    className=" editbutton"
                                  >
                                    Done
                                  </Link>
                                )}
                              </div>
                            ) : null}
                          </TableCell>
                          <TableCell align="center">
                            <Checkbox
                              checked={item.showInPrescription || false}
                              onChange={(e) =>
                                handlePrescriptionCheckbox(
                                  item._id,
                                  e.target.checked,
                                )
                              }
                            />
                          </TableCell>
                          <TableCell align="left">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Link
                                sx={{ fontSize: { xs: 15, sm: 18 } }}
                                onClick={() =>
                                  isMobile
                                    ? openDrawerWithModal(
                                        "editinwards",
                                        item._id,
                                      )
                                    : props.onEditTreatment?.(item)
                                }
                              >
                                <ModeEditOutlineSharp
                                  style={{ marginLeft: 15, fontSize: 20 }}
                                />
                              </Link>

                              <Link
                                sx={{ fontSize: { xs: 15, sm: 18 } }}
                                onClick={() => handleDeleteShow(item._id)}
                              >
                                <DeleteIcon
                                  style={{ marginLeft: 15, fontSize: 20 }}
                                />
                              </Link>
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        ) : null}
      </>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="alert modalColor">
            You want to complete this Treatment.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="default"
            className="appColor"
            onClick={() => handleDone(treatmentId)}
          >
            Yes
          </Button>
          <Button
            variant="default"
            className="borderStyle"
            onClick={handleClose}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>

      <div>
        <Modal show={showDelete} onHide={handleDeleteClose}>
          <Modal.Header closeButton>
            <Modal.Title>Are you sure?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="alert modalColor">
              You want to delete this data.
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="default"
              className="appColor"
              onClick={() => deletetreatments(treatmentId)}
            >
              Yes
            </Button>
            <Button
              variant="default"
              style={{ border: `1px solid ${THEME_COLOR} ` }}
              onClick={handleDeleteClose}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}
